
<facnm-header [pagetitle]="pageTitle" ></facnm-header>
<div class="contentBox"  [ngClass]="{'white-bg': pageTitle != 'Login'}">
    <router-outlet class="contentBox" ></router-outlet>
</div>
<facnm-footer ></facnm-footer>